module.exports = __webpack_public_path__ + "img/gamblers_anonymous.72576617.svg";